import { IonButton, IonCardTitle, IonCol, IonGrid, IonIcon, IonInput, IonRow, IonText } from '@ionic/react'
import React, { useEffect, useState } from 'react'
import { useGlobalStore } from './stateManagement/globalZustand'
import { useTreeStore } from './stateManagement/treeZustand';
import { useUserStore } from './stateManagement/userZustand';
import { _ACTIVITY_ROOT, _NEW_LINE, _TEMPLATE_A, _cardFontSizeMax, _cardFontSizeMin, _cardWidthMax, _cardWidthMin, _defaultButtonColor, _defaultParams, _dict, _emptyLabel, _freeCards } from './constants';
import { logMe } from '../foo/user';
import { goToPayment } from './payments';
import { calculateCardAndFontSize, getCardStyle, label2LabelToShow } from '../foo/cards';
import { useURLStore } from './stateManagement/URLZustand';
import { caretDownOutline, checkmark, imagesOutline, returnDownBack, returnDownBackOutline } from 'ionicons/icons';
import { displayPic } from './usePhotoGallery';
import ButtonTemplate from './templates/ButtonTemplate';

interface CardZero {
    label: string;
    image: string;
    backgroundColor?: string | "white";
    isBorderHighlighted?: boolean | false;
    isBorderBlack?: boolean | false;
    icons: any[];
    spinnerIfNoImage?: boolean | false;
    hasInput?: boolean | false;
    inputRef?: any;
    inputInitialValue?: string;
    inputHandleInputChange?: (event: any) => void;
    inputHandleKeyPress?: (event: any) => void;
    inputHandleBlur?: (event: any) => void;
    inputConfirmCallback?: () => void;


}
const CardZero: React.FC<CardZero> = (props: CardZero) => {
    const { lang, isParentMode } = useGlobalStore();
    const { URLVars } = useURLStore();
    const { freeNodes, path2Params, defaultParams } = useTreeStore();
    const { isSubscribed, userUniqueId } = useUserStore();
    //const [ cardImg, setCardImg] = useState<string | undefined>(undefined);
    

    const capitalizeText = path2Params[URLVars.nodePath!]?.capitalizeText || defaultParams.capitalizeText;
    const invertImgTxt = path2Params[URLVars.nodePath!]?.invertImgTxt || defaultParams.invertImgTxt;
    const labelToShow = label2LabelToShow(props.label, lang, capitalizeText);


    //const { CW: cardSize, FS: fontSize } = calculateCardAndFontSize(cardSizeMultiplier, visibleLabels, _cardFontSizeMin, _cardFontSizeMax, _cardWidthMin, _cardWidthMax, labelToShow);
    const cardSize = path2Params[URLVars.nodePath!]?.cardWidth || defaultParams.cardWidth;
    const fontSize = path2Params[URLVars.nodePath!]?.fontSize || defaultParams.fontSize;
    let titleJSX;
    let imageJSX;

    /*useEffect(() => {
        setCardImg(getImage(props.label));
    }, [l2Image[props.label]]);*/
    
    let styleDict;
    if (props.label === _dict.clickHereToAddACard[lang]) {
        
        // EMPTY CARD HERE
        styleDict = getCardStyle(cardSize, fontSize, null, props.backgroundColor, props.isBorderHighlighted, isParentMode ? props.isBorderBlack : false);
        return (
            <IonGrid style={{...styleDict, background: isParentMode ? "#f6f7f8" : "white"}}>
                <IonRow>
                    <IonCol className={"ion-text-center"} >
                        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: "100%", minHeight: cardSize.cardWidth}}>
                            {isParentMode ? _dict.clickHereToAddACard[lang] : null}
                        </div>
                    </IonCol>
                </IonRow>
            </IonGrid>
        );
    }
    if (!props.hasInput && props.label.includes(_NEW_LINE)){
        styleDict = getCardStyle(cardSize, fontSize, invertImgTxt, props.backgroundColor, props.isBorderHighlighted, isParentMode ? props.isBorderBlack : false);
        return (
            <IonGrid style={{...styleDict, padding:"0px"}}>
            <IonRow style={{ height: '100%', alignItems: 'center',  padding:"0px", margin:"0px"}}>
            <IonCol className={"ion-text-center"} style={{ padding:"0px", margin:"0px",
            display:"flex", alignItems: 'center', justifyContent:"center", color:"white", fontWeight:"bold",  minHeight:"100%", height:"100%",
            background: '#1a1a1a', border: 'none',  overflow: 'hidden', borderRadius: '10px'}}>            
                <div style={{ display:"flex", position: 'absolute', justifyContent:"center", alignItems: 'center',padding:"0px", margin:"0px", top: 0, left: 0, width: '100%', height: '100%', background: 'repeating-linear-gradient(45deg, transparent, transparent 10px, rgba(255, 255, 255, 0.2) 10px, rgba(255, 255, 255, 0.2) 20px)' }}>
                    {_dict.newLine[lang]}
                    <IonIcon icon={returnDownBackOutline} color='light' />
                </div>
            </IonCol>
            </IonRow>
            </IonGrid>
        );
    }
    styleDict = getCardStyle(cardSize, fontSize, invertImgTxt, props.backgroundColor, props.isBorderHighlighted, isParentMode ? props.isBorderBlack : false);

    //if (props.label === _emptyLabel || !isReady) {
    //    return <></>;
    //}

    if (!isSubscribed && freeNodes.length === _freeCards && props.label !== _dict.clickHereToAddACard[lang]) {
        // Generate a placeholder ioncard
        titleJSX = _dict.premiumCardPlaceholderMessage[lang]
        imageJSX = <IonButton
            onClick={() => { logMe("click_premium", { from: "outOfQuotaCard" }); goToPayment(userUniqueId) }}
            expand="full" style={{ "--background": _defaultButtonColor, fontSize: fontSize }} href="#">
            {_dict.freeQuotaPremiumBtnText[lang]}
        </IonButton>
    } else {
        titleJSX = props.label === _ACTIVITY_ROOT ? null : props.label === _TEMPLATE_A ? <><div><IonIcon icon={imagesOutline} size="large" /></div>{labelToShow}</> : labelToShow;

        imageJSX = <IonText className="ion-text-center" style={{ width: Math.max(((cardSize || 0) - 20), _cardWidthMin - 20) + "px" }}>
            {/*displayPic(cardImg, isParentMode, props.spinnerIfNoImage)*/}
            {displayPic(props.image, isParentMode, props.spinnerIfNoImage)}
        </IonText>;
    }

    return (
        <IonGrid style={styleDict}>
            <IonRow>
                <IonCol>
                    {props.hasInput && <>
                        <IonInput
                            ref={props.inputRef}
                            autofocus={true}
                            onIonInput={props.inputHandleInputChange}
                            onKeyDown={props.inputHandleKeyPress}
                            onBlur={props.inputHandleBlur}
                            color="dark"
                            value={label2LabelToShow(props.inputInitialValue || "", lang, capitalizeText)}

                            style={{
                                color: 'black',
                                '--ion-color-base': 'black',
                                '--ion-color-base-rgb': '0, 0, 0',
                                '--ion-color-contrast': 'black',
                                '--ion-color-contrast-rgb': '0, 0, 0',
                                '--ion-color-shade': 'black',
                                '--ion-color-tint': 'black',
                            }}
                        />
                        {props.inputConfirmCallback && <ButtonTemplate key={"b1"} onClick={props.inputConfirmCallback} icon={checkmark}  text={_dict.done[lang]} />}

                        </>
                    }
                </IonCol>
            </IonRow>

            {!props.hasInput && <IonRow>
                <IonCol>
                    <div className='ion-text-center'>
                        {invertImgTxt ? <>{titleJSX}{imageJSX}</> : <>{imageJSX}{titleJSX}</>}
                    </div>
                    
                </IonCol>
            </IonRow>}

            <IonRow>
                <IonCol className={"ion-text-center "}>
                    {props.icons.map((icon, index) => (
                        <IonIcon key={index} icon={icon} size="small" />
                    ))}
                </IonCol>
            </IonRow>
        </IonGrid>
    )
}

export default CardZero;